import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { parseDomain } from 'parse-domain';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { membershipInfoList } from '../constants/memberships';
import { postBrowserDetails } from '../containers/customerDetails/customerDetailsSlice';
import { getBrowserSignature } from '../utils/getBrowserSignature';

const MembershipServiceContext = createContext(null);

export const MembershipProvider = ({ children }) => {
	const dispatch = useDispatch();
	const [searchParams, setSearchParams] = useSearchParams();
	const signatureObj = getBrowserSignature();

	const { hasCompleted: postBrowserDetailsCompleted, result } = useSelector(
		(state) => state.customerDetailsSlice.postBrowserDetails
	);

	const { hasCompleted: submitCompleted } = useSelector(
		(state) => state.customerDetailsSlice.postNewMembershipSignup
	);

	const campaignId = searchParams.get('campaignId');
	const hostname = window.location.hostname;

	let membershipKey;
	if (hostname.endsWith('.localhost') || hostname === 'localhost') {
		const subdomain = hostname.replace('.localhost', '');
		membershipKey = subdomain === 'localhost' ? 'localhost' : subdomain;
	} else {
		const parsed = parseDomain(hostname);
		membershipKey = parsed?.domain || hostname;
	}

	const membershipListData = membershipInfoList[membershipKey];

	useEffect(() => {
		if (result.marketing_code && result.marketing_code !== campaignId) {
			searchParams.delete('campaignId');
			setSearchParams(searchParams);
		}
	}, [result]);

	useEffect(() => {
		if (!postBrowserDetailsCompleted) {
			dispatch(
				postBrowserDetails({
					campaignId,
					clubCategory: membershipListData?.clubCategory,
					browserSignature: signatureObj.signatureKey
				})
			);
		}
	}, [campaignId, submitCompleted]);

	const value = {
		membershipListData,
		result,
		campaignId
	};

	return (
		<MembershipServiceContext.Provider value={value}>
			{children}
		</MembershipServiceContext.Provider>
	);
};

MembershipProvider.propTypes = {
	children: PropTypes.node.isRequired
};

export const useMembership = () => {
	const context = useContext(MembershipServiceContext);
	if (!context) {
		throw new Error('useMembership must be used within a MembershipProvider');
	}
	return context;
};
